module.exports = __webpack_public_path__ + "static/media/Investography- Redemption Process.2f643503.pdf";